import { Card, ErrorFallback } from "materia"
import { useTranslation } from "react-i18next"
import s from "./JourneyTeaser.module.scss"

export const JourneyTeaserError = ({ error }: { error: unknown }) => {
  const { t } = useTranslation()
  return (
    <Card>
      <div className={s.error}>
        <ErrorFallback
          error={error}
          title={t("error.GENERIC")}
          message={t("error.JOURNEY_TEASER_FETCH_ERROR")}
        />
      </div>
    </Card>
  )
}
